import { Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/components/theme-provider";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "./context/AuthProvider";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/auth/Login";
import PrivateRoute from "./pages/PrivateRoute";
import ResetPassword from "./pages/auth/ResetPassword";
import ConfirmPassword from "./pages/auth/ConfirmPassword";
import VerifyEmail from "./pages/auth/VerifyEmail";
import ProfileSettings from "./pages/ProfileSettings";
import { ProfileProvider } from "./context/ProfileProvider";
import LandingPage from "./pages/Landing";
import NotFoundPage from "./pages/NotFound";
import Dashboard2 from "./pages/dashboard/Page";
import Layout2 from "./pages/Layout2";
import AccountListPage from "./pages/Accounts";
import AccountDetailPage from "./pages/account/Detail";
import { BalancePage } from "./pages/Balance";
import Princing from "./pages/Princing";
import Tips from "./pages/Tips";
import Invest from "./pages/Invest";
import { ReportView } from "./pages/Reports";
import ThankYouPage from "./pages/Thankyou";
import Register from "./pages/auth/Register";
import Home from "./pages/LandingNew";
import Terminos from "./pages/Terminos";
import Politica from "./pages/Politica";
function App() {
  return (
    <AuthProvider>
      <ProfileProvider>
        <ThemeProvider defaultTheme="system" storageKey="ui-theme">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/confirm-password" element={<ConfirmPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/dashboard2" element={<Dashboard2 />} />
            <Route path="/terminos-y-condiciones" element={<Terminos />} />
            <Route path="/politica-privacidad" element={<Politica />} />
            <Route
              path="/accounts"
              element={
                <PrivateRoute>
                  <Layout2 name="Cuentas">
                    <AccountListPage />
                  </Layout2>
                </PrivateRoute>
              }
            />
            <Route
              path="/tips"
              element={
                <PrivateRoute>
                  <Layout2 name="Tips">
                    <Tips />
                  </Layout2>
                </PrivateRoute>
              }
            />
            <Route
              path="/invest"
              element={
                <PrivateRoute>
                  <Layout2 name="Inversiones">
                    <Invest />
                  </Layout2>
                </PrivateRoute>
              }
            />
            <Route
              path="/report"
              element={
                <PrivateRoute>
                  <Layout2 name="Reportes">
                    <ReportView />
                  </Layout2>
                </PrivateRoute>
              }
            />
            <Route
              path="/accounts/:id"
              element={
                <PrivateRoute>
                  <Layout2 name="Cuentas">
                    <AccountDetailPage />
                  </Layout2>
                </PrivateRoute>
              }
            />
            <Route
              path="/balance"
              element={
                <PrivateRoute>
                  <Layout2 name="Balance">
                    <BalancePage />
                  </Layout2>
                </PrivateRoute>
              }
            />
            <Route
              path="/pricing"
              element={
                <PrivateRoute>
                  <Layout2 name="Planes">
                    <Princing />
                  </Layout2>
                </PrivateRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Layout2 name="Dashboard">
                    {/* <RoleGuard roles={["owner", "admin", "user"]}> */}
                    {/* <Layout> */}
                    <Dashboard />
                    {/* </Layout> */}
                    {/* </RoleGuard> */}
                  </Layout2>
                </PrivateRoute>
              }
            />
            <Route
              path="/gracias"
              element={
                <PrivateRoute>
                  <Layout2 name="Felicidades !!">
                    {/* <RoleGuard roles={["owner", "admin", "user"]}> */}
                    {/* <Layout> */}
                    <ThankYouPage />
                    {/* </Layout> */}
                    {/* </RoleGuard> */}
                  </Layout2>
                </PrivateRoute>
              }
            />

            <Route
              path="/profile"
              element={
                <PrivateRoute>
                  <Layout2 name="Perfil">
                    <ProfileSettings />
                  </Layout2>
                </PrivateRoute>
              }
            />

            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          <Toaster />
        </ThemeProvider>
      </ProfileProvider>
    </AuthProvider>
  );
}

export default App;
